import { __assign, __read, __rest } from "tslib";
import React, { useEffect, useState, forwardRef, useImperativeHandle, } from "react";
import ReactDOM, { unmountComponentAtNode } from "react-dom";
import { Modal } from "./ModalMain";
import { ConfigProvider } from "../configprovider";
/**
 * API 方式唤起一个对话框内容
 */
export function show(options) {
    var el = document.createElement("div");
    var instanceRef = React.createRef();
    // 创建销毁函数，用于真正销毁组件和DOM
    var destroyInstance = function () {
        if (options.destoryOnRoute !== false) {
            unmountComponentAtNode(el);
            if (el.parentNode) {
                el.parentNode.removeChild(el);
            }
        }
    };
    ReactDOM.render(React.createElement(ConfigProvider, null,
        React.createElement(ModalShow, __assign({}, options, { ref: instanceRef, onExited: destroyInstance, __onExited: destroyInstance }))), el);
    return {
        destroy: function () {
            if (instanceRef.current) {
                instanceRef.current.setVisible(false);
            }
        },
    };
}
var ModalShow = forwardRef(function ModalShow(props, ref) {
    var __onExited = props.__onExited, modalProps = __rest(props, ["__onExited"]);
    var _a = __read(useState(false), 2), visible = _a[0], setVisible = _a[1];
    // 渲染之后，马上显示
    useEffect(function () {
        setVisible(true);
    }, []);
    // 监听URL变化，直接调用onExited
    useEffect(function () {
        var handleLocationChange = function () {
            if (__onExited) {
                __onExited();
            }
        };
        // 监听popstate事件（浏览器前进后退）
        window.addEventListener("popstate", handleLocationChange);
        // 监听hashchange事件（hash路由变化）
        window.addEventListener("hashchange", handleLocationChange);
        return function () {
            window.removeEventListener("popstate", handleLocationChange);
            window.removeEventListener("hashchange", handleLocationChange);
        };
    }, [__onExited]);
    // 实例 ref 到外部
    useImperativeHandle(ref, function () { return ({ setVisible: setVisible }); });
    return React.createElement(Modal, __assign({}, modalProps, { visible: visible }));
});
//# sourceMappingURL=ModalShow.js.map